import { useAtom } from "jotai";
import React from "react";
import { Button } from "../../components/Button";
import { DEFAULT_CURSOR_SIZE } from "../../consts";
import {
  consoleOnAtom,
  defaultSpringDampingAtom,
  defaultSpringMassAtom,
  defaultSpringStiffnessAtom,
} from "../../jotai/atoms";
import { useFeatureFlags, useSpaceInfo } from "../../liveblocks/maps";
import { styled } from "../../stitches.config";
import {
  defaultFeatureFlags,
  featureFlagLabels,
  FeatureFlags,
} from "../../types";

function Console() {
  const [consoleOn, setConsoleOn] = useAtom(consoleOnAtom);
  const [featureFlags, featureFlagsClient] = useFeatureFlags();
  const [spaceInfo, spaceInfoClient] = useSpaceInfo();
  const cursorSize = spaceInfo?.cursorSize || DEFAULT_CURSOR_SIZE;
  const [stiffness, setStiffness] = useAtom(defaultSpringStiffnessAtom);
  const [damping, setDamping] = useAtom(defaultSpringDampingAtom);
  const [mass, setMass] = useAtom(defaultSpringMassAtom);

  if (!consoleOn) return <></>;

  return (
    <>
      <Panel>
        <div>
          <Slider
            label="Cursor Video Size"
            value={cursorSize}
            step={4}
            min={32}
            max={256}
            setter={(value: number) =>
              spaceInfoClient?.set("cursorSize", value)
            }
          />
        </div>

        <FlagList>
          {featureFlags &&
            Object.keys(defaultFeatureFlags).map((flag) => {
              if (!featureFlags) return <></>;
              return (
                <label key={flag}>
                  <input
                    type="checkbox"
                    name={flag}
                    checked={
                      featureFlags[flag as keyof FeatureFlags] ? true : false
                    }
                    onChange={() => {
                      if (!featureFlags) return;
                      featureFlagsClient?.set(
                        flag as keyof FeatureFlags,
                        !featureFlags[flag as keyof FeatureFlags]
                      );
                    }}
                  />{" "}
                  {featureFlagLabels[flag as keyof FeatureFlags]}
                </label>
              );
            })}
        </FlagList>

        <details>
          <summary>Spring Tweaks</summary>
          <ul>
            <Slider
              label="Default spring Stiffness"
              value={stiffness}
              setter={(value: number) => setStiffness(value)}
            />
            <Slider
              label="Default spring Damping"
              value={damping}
              setter={(value: number) => setDamping(value)}
            />
            <Slider
              label="Default spring Mass"
              value={mass}
              setter={(value: number) => setMass(value)}
            />
          </ul>
        </details>

        <details>
          <summary>Sentry test</summary>
          <button
            type="button"
            onClick={() => {
              throw new Error("Sentry Frontend Error");
            }}
          >
            Throw test error
          </button>
        </details>

        <Button
          style={{ position: "absolute", right: "0", top: "0" }}
          icon="Close"
          color="secondary"
          size=""
          onClick={() => {
            setConsoleOn(false);
          }}
        ></Button>
      </Panel>
    </>
  );
}

export default React.memo(Console);

const FlagList = styled("section", {
  label: {
    display: "flex",
    alignItems: "center",
    // padding: "$2",
    marginBottom: "$4",
    cursor: "pointer",

    input: {
      marginRight: "$2",
    },
  },
});

const Panel = styled("aside", {
  width: "50vw",
  overflow: "hidden",
  padding: "1rem",
  background: "$menuBeige",
  backgroundBlur: "",
  borderRadius: ".25rem",
  cursor: "default",
  position: "fixed",
  left: "$2",
  bottom: "$2",
  listStyle: "none",
  zIndex: "$console",
  elevation: 3,

  details: {},

  summary: {
    marginBottom: "$4",
  },

  section: {
    marginBottom: "$4",
  },
});

const MessageListItem = styled("li", {
  marginBottom: "1rem",
});

export function Slider({
  label,
  value,
  setter,
  min = 0,
  max = 500,
  step = 1,
}: {
  label: string;
  value: number;
  setter: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
}) {
  return (
    <MessageListItem>
      <label>
        {`${label}: ${value}`}
        <input
          style={{
            width: "100%",
          }}
          type="range"
          value={value}
          min={min}
          max={max}
          step={step}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setter(Number(e.target.value))
          }
        />
      </label>
    </MessageListItem>
  );
}
